import {z} from "zod/v4-mini"

export const componentOptions = ["x", "y", "z", "xy", "xz", "yx", "yz", "zx", "zy"] as const
export type ComponentOption = (typeof componentOptions)[number]
export const componentOption: z.ZodMiniType<ComponentOption, ComponentOption> = z.enum(componentOptions)

export const unaryMathOperatorOptions = ["not", "sin", "cos", "norm", "normalize", "sqrt", "recip", "recipSqrt", "exp", "log", "neg"] as const
export type UnaryMathOperatorOption = (typeof unaryMathOperatorOptions)[number]
export const unaryMathOperatorOption: z.ZodMiniType<UnaryMathOperatorOption, UnaryMathOperatorOption> = z.enum(unaryMathOperatorOptions)

export const binaryMathOperatorOptions = ["add", "sub", "mul", "div", "mod", "gt", "lt", "eq", "ne", "lte", "and", "or", "gte", "cross"] as const
export type BinaryMathOperatorOption = (typeof binaryMathOperatorOptions)[number]
export const binaryMathOperatorOption: z.ZodMiniType<BinaryMathOperatorOption, BinaryMathOperatorOption> = z.enum(binaryMathOperatorOptions)

export type MathOperatorOption = UnaryMathOperatorOption | BinaryMathOperatorOption
export const mathOperatorOptions = [...unaryMathOperatorOptions, ...binaryMathOperatorOptions] as const
export const mathOperatorOption: z.ZodMiniType<MathOperatorOption, MathOperatorOption> = z.union([unaryMathOperatorOption, binaryMathOperatorOption])

export const isUnaryMathOperatorOption = (value: string): value is UnaryMathOperatorOption => (unaryMathOperatorOptions as readonly string[]).includes(value)
export const isBinaryMathOperatorOption = (value: string): value is BinaryMathOperatorOption => (binaryMathOperatorOptions as readonly string[]).includes(value)
export const isMathOperatorOption = (value: string): value is MathOperatorOption => isUnaryMathOperatorOption(value) || isBinaryMathOperatorOption(value)

export const constOperatorTypeOptions = ["float", "int", "like"] as const
export type ConstOperatorTypeOption = (typeof constOperatorTypeOptions)[number]
export const constOperatorTypeOption: z.ZodMiniType<ConstOperatorTypeOption, ConstOperatorTypeOption> = z.enum(constOperatorTypeOptions)

export const castOperatorTypeOptions = ["float", "int"] as const
export type CastOperatorTypeOption = (typeof castOperatorTypeOptions)[number]
export const castOperatorTypeOption: z.ZodMiniType<CastOperatorTypeOption, CastOperatorTypeOption> = z.enum(castOperatorTypeOptions)

export const reduceOperatorOptions = ["min", "max"] as const
export type ReduceOperatorOption = (typeof reduceOperatorOptions)[number]
export const reduceOperatorOption: z.ZodMiniType<ReduceOperatorOption, ReduceOperatorOption> = z.enum(reduceOperatorOptions)

export const pointGeometryPrimitiveOptions = ["pointSet1", "pointSet2", "pointSet3", "linePoints1", "linePoints2", "linePoints3"] as const
export type PointGeometryPrimitiveOption = (typeof pointGeometryPrimitiveOptions)[number]

export const curveGeometryPrimitiveOptions = ["line1", "line2", "line3"] as const
export type CurveGeometryPrimitiveOption = (typeof curveGeometryPrimitiveOptions)[number]

export const meshGeometryPrimitiveOptions = ["grid2"] as const
export type MeshGeometryPrimitiveOption = (typeof meshGeometryPrimitiveOptions)[number]
